import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Login from '@/views/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import Profile from '@/views/Profile.vue';
import Password from '@/views/Password.vue';
import WinLoseMember from '@/views/WinLoseMember.vue';
import ProviderReport from '@/views/ProviderReport.vue';
import GameReport from '@/views/GameReport.vue';
import HighValueReport from '@/views/HighValueReport.vue';
import UserOnline from '@/views/UserOnline.vue';
import Downline from '@/views/Downline.vue';
import SubAccount from '@/views/SubAccount.vue';
import DepositWithdraw from '@/views/DepositWithdraw.vue';
import SuggestMember from '@/views/SuggestMember.vue';
import store from '@/store';
import Message from '@/views/Message.vue';
import Banner from '@/views/Banner.vue';
import BetCancel from '@/views/BetCancel.vue';
import Payout from '@/views/Payout.vue';
import Recal from '@/views/Recal.vue';
import AddSubAccount from '@/views/AddSubAccount.vue';
import AddAgent from '@/views/AddAgent.vue';
import EditAgent from '@/views/EditAgent.vue';
import AddMember from '@/views/AddMember.vue';
import EditMember from '@/views/EditMember.vue';
import EditSubAccount from '@/views/EditSubAccount.vue';
import SeamlessKey from '@/views/SeamlessKey.vue';
import TransferKey from '@/views/TransferKey.vue';
import Social from '@/views/Social.vue';
import Promotion from '@/views/Promotion.vue';
import MechanicReport from '@/views/MechanicReport.vue';
// ADMIN
import GameMessage from '@/views/GameMessage.vue';
import GameVersion from '@/views/GameVersion.vue';
import GameVersionControl from '@/views/GameVersionControl.vue';
import SecureCode from '@/views/SecureCode.vue';
import Bankaccount from '@/views/BankAccount.vue';
import Invoice from '@/views/Invoice.vue';
import DocumentApi from '@/views/DocumentApi.vue';
import RateCurrency from '@/views/RateCurrency.vue';
import ResetPasswordLog from '@/views/ResetPasswordLog.vue';
import SecretPassword from '@/views/SecretPassword.vue';
import ActiveAgent from '@/views/ActivityAgent.vue';
import Point from '@/views/Point.vue';
import ActivityLog from '@/views/Activity.vue';
import Feature from '@/views/FeatureView.vue';
import UserSeamlessProblem from '@/views/UserSeamlessProblem.vue';
import PaymentLog from '@/views/PaymentLog.vue';
import UpdateCommissionLog from '@/views/UpdateCommissionLog.vue';
import DemoUrl from '@/views/DemoUrl.vue';
import LegendOfDolly from '@/views/LegendOfDolly.vue';
import LogAdmin from '@/views/LogAdmin.vue';
import User from '@/views/User.vue';
import Theme from '@/views/Theme.vue';
import Lobby from '@/views/Lobby.vue';
import agentSetting from '@/views/AgentSetting.vue';
import landingPageSetting from '@/views/LandingPageSetting.vue';
import themeSelection from '@/views/ThemeSelection.vue';
import rtpManagement from '@/views/RtpManagement.vue';
import rtpAgentManagement from '@/views/RtpAgentManagement.vue';
import riskManagement from '@/views/RiskManagement.vue';
import Mascot from '@/views/Mascot.vue';
import Angpow from '@/views/Angpow.vue';
import Coin from '@/views/Coin.vue';
import Url from '@/views/AddUrl.vue';
import WinloseMechanic from '@/views/WinloseMechanic.vue';
import PatternVersion from '@/views/PatternVersion.vue';
import DomainPool from '@/views/DomainPool.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: {
      name: 'Dashboard',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      guest: true,
      layout: 'auth',
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/password',
    name: 'Password',
    component: Password,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/winlosemember',
    name: 'WinLoseMember',
    component: WinLoseMember,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/winlosemechanic',
    name: 'WinLoseMechanic',
    component: WinloseMechanic,
    meta: {
      requiresAuth: true,
      permKey: 'reportMechanic',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/provider-report',
    name: 'ProviderReport',
    component: ProviderReport,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/game-report',
    name: 'GameReport',
    component: GameReport,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
      ],
    },
  },
  {
    path: '/high-value-report',
    name: 'HighValueReport',
    component: HighValueReport,
    meta: {
      requiresAuth: true,
      permKey: 'report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/mechanic-report',
    name: 'MechanicReport',
    component: MechanicReport,
    meta: {
      requiresAuth: true,
      permKey: 'reportMechanic',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        // 'AGENT',
      ],
    },
  },
  {
    path: '/deposit-withdraw',
    name: 'DepositWithdraw',
    component: DepositWithdraw,
    meta: {
      requiresAuth: true,
      permKey: 'statement',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/useronline',
    name: 'UserOnline',
    component: UserOnline,
    meta: {
      requiresAuth: true,
      permKey: 'useronline',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/downline',
    name: 'Downline',
    component: Downline,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/subaccount',
    name: 'SubAccount',
    component: SubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
    },
  },
  {
    path: '/add-subaccount',
    name: 'AddSubAccount',
    component: AddSubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
    },
  },
  {
    path: '/edit-subaccount',
    name: 'EditSubAccount',
    component: EditSubAccount,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'AGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/add-agent',
    name: 'AddAgent',
    component: AddAgent,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'AGENT',
        // 'SUBAGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/edit-agent',
    name: 'EditAgent',
    component: EditAgent,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUBAGENT',
        'ADMIN',
        'AGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/add-member',
    name: 'AddMember',
    component: AddMember,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'AGENT',
        // 'SUBAGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/edit-member',
    name: 'EditMember',
    component: EditMember,
    meta: {
      requiresAuth: true,
      permKey: 'member',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'AGENT',
        'SUBAGENT',
      ],
      isEditPermKey: 'member',
    },
  },
  {
    path: '/suggest-member',
    name: 'SuggestMember',
    component: SuggestMember,
    meta: {
      requiresAuth: true,
      permKey: 'suggestion',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
      ],
    },
  },
  {
    path: '/seamless-key',
    name: 'SeamlessKey',
    component: SeamlessKey,
    meta: {
      permKey: 'apikey',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/transfer-key',
    name: 'TransferKey',
    component: TransferKey,
    meta: {
      permKey: 'apikey',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/social',
    name: 'Social',
    component: Social,
    meta: {
      permKey: 'social',
      requiresAuth: true,
      allow: [
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/promotion',
    name: 'Promotion',
    component: Promotion,
    meta: {
      requiresAuth: true,
      allow: [
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/game-version',
    name: 'GameVersion',
    component: GameVersion,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
        'ADMIN',
      ],
    },
  },
  {
    path: '/pattern-version',
    name: 'Pattern',
    component: PatternVersion,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
        'ADMIN',
      ],
    },
  },

  {
    path: '/game-version-control',
    name: 'GameVersionControl',
    component: GameVersionControl,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/game-message',
    name: 'GameMessage',
    component: GameMessage,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
      ],
    },
  },
  {
    path: '/demo-url',
    name: 'DemoUrl',
    component: DemoUrl,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/secure',
    name: 'SecureCode',
    component: SecureCode,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'AGENT',
      ],
    },
  },
  {
    path: '/message',
    name: 'Message',
    component: Message,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/banner',
    name: 'Banner',
    component: Banner,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/bet-cancel',
    name: 'BetCancel',
    component: BetCancel,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/payout',
    name: 'Payout',
    component: Payout,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/recal',
    name: 'Recal',
    component: Recal,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/bank-account',
    name: 'Bankaccount',
    component: Bankaccount,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: Invoice,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/documentapi',
    name: 'DocumentApi',
    component: DocumentApi,
    meta: {
      requiresAuth: true,
      allow: [
        'AGENT',
        'ADMIN',
        'SUPERADMIN',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/ratecurrency',
    name: 'RateCurrency',
    component: RateCurrency,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/reset-passlog',
    name: 'Reset Password Log',
    component: ResetPasswordLog,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/update-commission-log',
    name: 'Update Commission Log',
    component: UpdateCommissionLog,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/secret-password',
    name: 'SecretPassword',
    component: SecretPassword,
    meta: {
      permKey: 'admin',
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/access-logs',
    name: 'AccessLogs',
    component: ActiveAgent,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'AGENT',
        'SUBACCOUNT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/point',
    name: 'Point',
    component: Point,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
        'SUBACCOUNT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/coin',
    name: 'Coin',
    component: Coin,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
        'SUBACCOUNT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/url',
    name: 'Url',
    component: Url,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
        'AGENT',
        'SUBACCOUNT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/legend-of-dolly',
    name: 'Legend of dolly',
    component: LegendOfDolly,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/activity',
    name: 'ActivityLog',
    component: ActivityLog,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/feature',
    name: 'Feature',
    component: Feature,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'AGENT',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/mascot',
    name: 'Mascot',
    component: Mascot,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/angpow',
    name: 'Angpow',
    component: Angpow,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/user-seamless-problem',
    name: 'User Seamless',
    component: UserSeamlessProblem,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/paymentlog',
    name: 'PaymentLog',
    component: PaymentLog,
    meta: {
      requiresAuth: true,
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'AGENT',
        'SUBACCOUNT',
        'SUBAGENT',
      ],
    },
  },
  {
    path: '/log-admin',
    name: 'LogAdmin',
    component: LogAdmin,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/user',
    name: 'User',
    component: User,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
  {
    path: '/backoffice',
    name: 'BO',
    component: Theme,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/lobby',
    name: 'LB',
    component: Lobby,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
      ],
    },
  },
  {
    path: '/agentsetting',
    name: 'BO',
    component: agentSetting,
    meta: {
      requiresAuth: true,
      allow: [
        'AGENT',
      ],
    },
  },
  {
    path: '/landingpagesetting',
    name: 'BO',
    component: landingPageSetting,
    meta: {
      requiresAuth: true,
      allow: [
        'AGENT',
      ],
    },
  },
  {
    path: '/themeselection',
    name: 'BO',
    component: themeSelection,
    meta: {
      requiresAuth: true,
      requiresWhiteLabel: true,
      allow: [
        'AGENT',
      ],
    },
  },
  {
    path: '/rtp-management',
    name: 'RTPM',
    component: rtpManagement,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/rtp-agent-management',
    name: 'RTPAM',
    component: rtpAgentManagement,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/rtp-riskmanagement',
    name: 'RM',
    component: riskManagement,
    meta: {
      requiresAuth: true,
      allow: [
        'SUPERADMIN',
      ],
    },
  },
  {
    path: '/domain-pool',
    name: 'DomainPool',
    component: DomainPool,
    meta: {
      requireAuth: true,
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const {
    isAuthenticated, userPermission, role,
  } = store.getters;
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      if ((userPermission[to.meta?.permKey] !== 'off'
        && to.meta?.allow.includes(role))
        && (!to.meta.isEditPermKey
        || userPermission[to.meta.isEditPermKey] === 'edit')) {
        next();
        return;
      } else {
        next('/dashboard');
        return;
      }
    }
    next('/login');
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (!isAuthenticated) {
      next();
      return;
    }
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
